import { render, staticRenderFns } from "./NextArrow.vue?vue&type=template&id=f6048286&scoped=true&"
import script from "./NextArrow.vue?vue&type=script&lang=js&"
export * from "./NextArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6048286",
  null
  
)

export default component.exports